(function () {
  'use strict';

  document.querySelectorAll('[data-ef-root]').forEach(function (root) {

    var node = root.querySelector('[data-ef-product-json]');
    if (!node) return;

    var product;

    try {
      product = JSON.parse(node.textContent);
    } catch (e) {
      return;
    }


    var flowers = Array.from(
      root.querySelectorAll('[data-ef-flower]')
    );

    var scents = Array.from(
      root.querySelectorAll('[data-ef-scent]')
    );


    var result = root.querySelector('[data-ef-result]');
    var image = root.querySelector('[data-ef-result-image]');

    var flowerText = root.querySelector(
      '[data-ef-result-flower]'
    );

    var scentText = root.querySelector(
      '[data-ef-result-scent]'
    );

    var priceText = root.querySelector(
      '[data-ef-result-price]'
    );

    var status = root.querySelector('[data-ef-status]');
    var add = root.querySelector('[data-ef-add]');


    /* ==============================
       最下部の購入フォーム
    ============================== */

    var finalImage = root.querySelector(
      '[data-ef-final-image]'
    );

    var finalFlower = root.querySelector(
      '[data-ef-final-flower]'
    );

    var finalScent = root.querySelector(
      '[data-ef-final-scent]'
    );

    var finalVariantId = root.querySelector(
      '[data-ef-final-variant-id]'
    );

    var finalPrice = root.querySelector(
      '[data-ef-final-price]'
    );

    var finalAdd = root.querySelector(
      '[data-ef-final-add]'
    );

    var finalPayment = root.querySelector(
      '[data-ef-final-payment]'
    );


    /* ==============================
       初期画像
    ============================== */

    function getImageUrl(value) {

      if (!value) return '';

      if (typeof value === 'string') {
        return value;
      }

      return value.src || value.url || '';
    }


    var productImage =
      getImageUrl(product.featured_image) ||
      getImageUrl(
        product.images &&
        product.images[0]
      );


    var bloomButton = flowers.find(
      function (button) {

        return String(
          button.dataset.efFlower || ''
        )
          .trim()
          .toUpperCase() === 'BLOOM';

      }
    );


    var bloomImage =
      bloomButton
        ? bloomButton.dataset.efImage || ''
        : '';


    var firstFlowerImage =
      flowers.length > 0
        ? flowers[0].dataset.efImage || ''
        : '';


    var defaultImage =
      bloomImage ||
      productImage ||
      firstFlowerImage;


    var state = {

      flower: '',

      scent: '',

      image: defaultImage,

      alt: product.title || 'ETERNAL FLOWER'

    };


    /* ==============================
       オプション名の判定
    ============================== */

    function norm(value) {

      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s　_\-・]/g, '');

    }


    function optionIndex(pattern, fallback) {

      var index = (product.options || []).findIndex(
        function (value) {

          return pattern.test(
            norm(value)
          );

        }
      );

      return index < 0
        ? fallback
        : index;

    }


    var flowerIndex = optionIndex(
      /花|flower/,
      0
    );


    var scentIndex = optionIndex(
      /香|fragrance|scent|aroma/,
      flowerIndex === 0
        ? 1
        : 0
    );


    /* ==============================
       価格表示
    ============================== */

    function money(cents) {

      return (
        '¥' +
        Math.round(
          Number(cents || 0) / 100
        ).toLocaleString('ja-JP') +
        '（税込）'
      );

    }


    /* ==============================
       選択中のバリエーション取得
    ============================== */

    function variant() {

      if (
        !state.flower ||
        !state.scent
      ) {

        return null;

      }


      return (
        product.variants || []
      ).find(
        function (item) {

          return (

            norm(
              item.options[flowerIndex]
            ) ===
              norm(state.flower) &&

            norm(
              item.options[scentIndex]
            ) ===
              norm(state.scent)

          );

        }
      ) || null;

    }


    /* ==============================
       在庫判定
    ============================== */

    function hasAvailableVariant(
      flower,
      scent
    ) {

      return (
        product.variants || []
      ).some(
        function (item) {

          if (!item.available) {
            return false;
          }


          var flowerMatches =
            !flower ||
            norm(
              item.options[flowerIndex]
            ) ===
              norm(flower);


          var scentMatches =
            !scent ||
            norm(
              item.options[scentIndex]
            ) ===
              norm(scent);


          return (
            flowerMatches &&
            scentMatches
          );

        }
      );

    }


    /* ==============================
       SOLD OUT表示
    ============================== */

    function setStockState(
      button,
      soldOut
    ) {

      button.disabled =
        soldOut;


      button.classList.toggle(
        'is-sold-out',
        soldOut
      );


      button.setAttribute(
        'aria-disabled',
        soldOut
          ? 'true'
          : 'false'
      );


      var label =
        button.querySelector(
          '.ef-stock-label'
        );


      if (soldOut) {

        if (!label) {

          label =
            document.createElement(
              'span'
            );


          label.className =
            'ef-stock-label';


          label.textContent =
            'SOLD OUT';


          label.setAttribute(
            'aria-label',
            '在庫切れ'
          );


          button.appendChild(
            label
          );

        }

      } else {

        if (label) {
          label.remove();
        }

      }

    }

/* ==============================
   最下部プルダウンの
   SOLD OUT表示
============================== */

function refreshFinalSelectStock() {


  /* お花 */

  if (finalFlower) {

    Array.from(
      finalFlower.options
    ).forEach(function (option) {

      if (!option.value) {
        return;
      }


      if (!option.dataset.originalLabel) {

        option.dataset.originalLabel =
          option.textContent.trim();

      }


      var soldOut =
        !hasAvailableVariant(
          option.value,
          ''
        );


      option.disabled =
        soldOut;


      option.textContent =
        option.dataset.originalLabel +
        (
          soldOut
            ? '｜SOLD OUT'
            : ''
        );

    });

  }


  /* 香り */

  if (finalScent) {

    Array.from(
      finalScent.options
    ).forEach(function (option) {

      if (!option.value) {
        return;
      }


      if (!option.dataset.originalLabel) {

        option.dataset.originalLabel =
          option.textContent.trim();

      }


      var soldOut =
        !hasAvailableVariant(
          state.flower || '',
          option.value
        );


      option.disabled =
        soldOut;


      option.textContent =
        option.dataset.originalLabel +
        (
          soldOut
            ? '｜SOLD OUT'
            : ''
        );

    });

  }

}

    /* ==============================
       花・香りの在庫状態を更新
    ============================== */

    function refreshStock() {


      /*
        STEP 1｜花

        その花で購入できる在庫が
        1種類もなければ
        最初からSOLD OUT
      */

      flowers.forEach(
        function (button) {

          var flower =
            button.dataset.efFlower;


          var soldOut =
            !hasAvailableVariant(
              flower,
              ''
            );


          setStockState(
            button,
            soldOut
          );

        }
      );


      /*
        STEP 2｜香り

        花がまだ未選択
        ↓
        その香り自体が
        全商品SOLD OUTなら表示

        花を選択済み
        ↓
        その花で購入できない香りを
        SOLD OUT表示
      */

      scents.forEach(
        function (button) {

          var scent =
            button.dataset.efScent;


          var soldOut =
            !hasAvailableVariant(
              state.flower || '',
              scent
            );


          setStockState(
            button,
            soldOut
          );

        }
      );


      /*
        花を変更して、
        前に選んだ香りが
        新しい花ではSOLD OUTの場合

        香りの選択を解除
      */

      if (
        state.flower &&
        state.scent &&
        !hasAvailableVariant(
          state.flower,
          state.scent
        )
      ) {

        state.scent = '';

        select(
          scents,
          null
        );

      }

      refreshFinalSelectStock();

    }


    /* ==============================
       選択状態の表示
    ============================== */

    function select(
      buttons,
      current
    ) {

      buttons.forEach(
        function (button) {

          var active =
            button === current;


          button.classList.toggle(
            'is-selected',
            active
          );


          button.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );

        }
      );

    }


    function matchingButton(
      buttons,
      datasetKey,
      value
    ) {

      return buttons.find(
        function (button) {

          return (
            norm(
              button.dataset[datasetKey]
            ) ===
            norm(value)
          );

        }
      ) || null;

    }


    /* ==============================
       最下部フォームを同期
    ============================== */

    function syncFinal(
      selectedVariant
    ) {


      if (finalFlower) {

        finalFlower.value =
          state.flower || '';

      }


      if (finalScent) {

        finalScent.value =
          state.scent || '';

      }


      if (finalVariantId) {

        finalVariantId.value =
          selectedVariant
            ? selectedVariant.id
            : '';

      }


      if (finalAdd) {

        finalAdd.disabled =
          !selectedVariant ||
          !selectedVariant.available;

      }


      if (finalPayment) {

        finalPayment.hidden =
          !selectedVariant ||
          !selectedVariant.available;

      }


      if (finalPrice) {

        finalPrice.textContent =
          money(
            selectedVariant
              ? selectedVariant.price
              : product.price
          );

      }


      if (
        finalImage &&
        state.image
      ) {

        finalImage.src =
          state.image;


        finalImage.alt =
          state.alt ||
          (
            state.flower
              ? 'ETERNAL FLOWER ' +
                state.flower
              : 'ETERNAL FLOWER'
          );


        finalImage.hidden = false;

      }

    }


    /* ==============================
       選択結果を更新
    ============================== */

    function update(scroll) {


      /*
        まず在庫表示を更新
      */

      refreshStock();


      var selectedVariant =
        variant();


      if (flowerText) {

        flowerText.textContent =
          state.flower ||
          'お花を選択してください';

      }


      if (scentText) {

        scentText.textContent =
          state.scent ||
          '香りを選択してください';

      }


      /* 未選択時にも初期画像を表示 */

      if (
        state.image &&
        image
      ) {

        image.src =
          state.image;


        image.alt =
          state.alt ||
          (
            state.flower
              ? 'ETERNAL FLOWER ' +
                state.flower
              : 'ETERNAL FLOWER'
          );


        image.hidden = false;

      }


      if (add) {

        add.dataset.variantId =
          selectedVariant
            ? selectedVariant.id
            : '';


        add.disabled =
          !selectedVariant ||
          !selectedVariant.available;

      }


      if (status) {


        if (
          !state.flower ||
          !state.scent
        ) {

          status.textContent =
            'お花と香りをひとつずつお選びください。';


        } else if (
          !selectedVariant
        ) {

          status.textContent =
            'この組み合わせの商品情報が見つかりませんでした。';


        } else if (
          !selectedVariant.available
        ) {

          status.textContent =
            '選択した組み合わせは、ただいまSOLD OUTです。別の花または香りをお選びください。';


        } else {

          status.textContent =
            '組み合わせをご確認のうえ、カートへお進みください。';

        }

      }


      if (priceText) {

        priceText.textContent =
          money(
            selectedVariant
              ? selectedVariant.price
              : product.price
          );

      }


      if (result) {

        result.classList.toggle(
          'is-ready',
          !!(
            state.image ||
            state.flower ||
            state.scent
          )
        );

      }


      syncFinal(
        selectedVariant
      );


      if (
        scroll &&
        state.flower &&
        state.scent &&
        result
      ) {

        setTimeout(
          function () {

            result.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

          },
          100
        );

      }

    }


    /* ==============================
       お花を選択
    ============================== */

    flowers.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {


            /*
              SOLD OUTなら何もしない
            */

            if (button.disabled) {
              return;
            }


            state.flower =
              button.dataset.efFlower;


            state.image =
              button.dataset.efImage ||
              defaultImage;


            state.alt =
              button.dataset.efAlt ||
              (
                'ETERNAL FLOWER ' +
                state.flower
              );


            select(
              flowers,
              button
            );


            /*
              花を変更した時、

              前に選択していた香りが
              新しい花ではSOLD OUTなら

              香り選択を解除
            */

            if (
              state.scent &&
              !hasAvailableVariant(
                state.flower,
                state.scent
              )
            ) {

              state.scent = '';

              select(
                scents,
                null
              );

            }


            update(false);


            /*
              花を選んだら
              STEP 2「香りを選ぶ」へ移動
            */

            var scentStep =
              root.querySelector(
                '.ef-step--scent'
              );


            if (scentStep) {

              setTimeout(
                function () {

                  scentStep.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });

                },
                180
              );

            }

          }
        );

      }
    );


    /* ==============================
       香りを選択
    ============================== */

    scents.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {


            /*
              SOLD OUTなら何もしない
            */

            if (button.disabled) {
              return;
            }


            state.scent =
              button.dataset.efScent;


            select(
              scents,
              button
            );


            update(true);

          }
        );

      }
    );


    /* ==============================
       最下部フォームから
       お花を選択
    ============================== */

    if (finalFlower) {

      finalFlower.addEventListener(
        'change',
        function () {


          state.flower =
            finalFlower.value;


          var button =
            matchingButton(
              flowers,
              'efFlower',
              state.flower
            );


          if (button) {

            state.image =
              button.dataset.efImage ||
              defaultImage;


            state.alt =
              button.dataset.efAlt ||
              (
                'ETERNAL FLOWER ' +
                state.flower
              );

          }


          /*
            下部フォームから
            花を変更した場合も

            香りがSOLD OUTになったら解除
          */

          if (
            state.scent &&
            !hasAvailableVariant(
              state.flower,
              state.scent
            )
          ) {

            state.scent = '';

            select(
              scents,
              null
            );

          }


          select(
            flowers,
            button
          );


          update(false);

        }
      );

    }


    /* ==============================
       最下部フォームから
       香りを選択
    ============================== */

    if (finalScent) {

      finalScent.addEventListener(
        'change',
        function () {


          state.scent =
            finalScent.value;


          var button =
            matchingButton(
              scents,
              'efScent',
              state.scent
            );


          select(
            scents,
            button
          );


          update(false);

        }
      );

    }


    /* ==============================
       上のカートへ追加
    ============================== */

    if (add) {

      add.addEventListener(
        'click',
        async function () {


          var id = Number(
            add.dataset.variantId
          );


          if (!id) {
            return;
          }


          var label =
            add.textContent;


          add.disabled = true;


          add.textContent =
            '追加中…';


          try {


            var response =
              await fetch(
                '/cart/add.js',
                {

                  method:
                    'POST',


                  headers: {

                    'Content-Type':
                      'application/json',

                    'Accept':
                      'application/json'

                  },


                  body:
                    JSON.stringify({

                      items: [

                        {

                          id: id,

                          quantity: 1

                        }

                      ]

                    })

                }
              );


            if (!response.ok) {


              var body =
                await response
                  .json()
                  .catch(
                    function () {

                      return {};

                    }
                  );


              throw new Error(
                body.description ||
                'カートへの追加に失敗しました。'
              );

            }


            add.textContent =
              'カートに追加しました ✓';


            if (status) {

              status.textContent =
                'カートに追加しました。';

            }


            document.dispatchEvent(
              new CustomEvent(
                'cart:refresh'
              )
            );


            document.dispatchEvent(
              new CustomEvent(
                'cart:updated'
              )
            );


            setTimeout(
              function () {


                add.textContent =
                  label;


                var current =
                  variant();


                add.disabled =
                  !current ||
                  !current.available;

              },
              2500
            );


          } catch (error) {


            if (status) {

              status.textContent =
                error.message ||
                'カートへの追加に失敗しました。';

            }


            add.textContent =
              label;


            var current =
              variant();


            add.disabled =
              !current ||
              !current.available;

          }

        }
      );

    }


    /* ==============================
       最下部フォーム
       有効な組み合わせのみ送信
    ============================== */

    if (finalAdd) {


      var finalForm =
        finalAdd.closest('form');


      if (finalForm) {


        finalForm.addEventListener(
          'submit',
          function (event) {


            var selectedVariant =
              variant();


            if (
              !selectedVariant ||
              !selectedVariant.available
            ) {

              event.preventDefault();

            }

          }
        );

      }

    }


    /* ==============================
       初期表示
    ============================== */

    update(false);

  });

})();